export default () => ({
  trigger: {
    name: 'top_navigation.select_home_button',
    params: {},
  },
  config: {
    event: {
      name: 'select_content',
      params: {
        content: 'home',
        sub_feature: null,
      },
    },
  },
});
